import { useQuery } from '@tanstack/react-query';
import { supportApi } from 'API/offline-reports-api';
import { sfAccountDataQueryKeys } from 'features/my-zone/support-requests/components/support-requests-modals/queries/sf-account-data-queries-keys';
import { useSelector } from 'react-redux';
import { userSelector } from 'store/selectors/app-selectors';

type AccountOwnerDataQueryResponse = {
    name: string;
    email: string;
};

export const useSFAccountOwnerDataQuery = () => {
    const user = useSelector(userSelector);
    const accountId = user?.settings?.account?.id;

    return useQuery<AccountOwnerDataQueryResponse>({
        queryKey: sfAccountDataQueryKeys.all(accountId!),
        enabled: !!accountId,
        queryFn: () => supportApi.getAccountOwnerData({ accountId: accountId! }),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};
